import styled from 'styled-components';

export const OfferReferralLinkStyled = styled.div`
    display: inline-flex;
    align-items: center;
    gap: var(--space-3);
    color: var(--color-accent);
    font-size: var(--font-size-md);
    font-weight: 400;

    span {
        word-break: break-all;
        min-width: 0;
    }

    .copy-button {
        flex-shrink: 0;
        font-size: var(--font-size-xs);
        padding: var(--space-1);
        border-radius: var(--radius-md);
        background: var(--background-neutral-10);
        border: 1px solid var(--background-neutral-10);
        margin-left: 0;
    }
`;
